module.exports = __webpack_public_path__ + "img/5.c4639a2e.jpg";